/**
 * Source images are heavier than what is displayed. This proxy (wsrv.nl,
 * free, CDN-backed) resizes them to the exact width, serves compressed WebP
 * and caches them long-term.
 */
const PROXY = 'https://wsrv.nl/'

export function optimizedImage(url: string, width: number, quality = 72): string {
  const params = new URLSearchParams({
    url,
    w: String(width),
    output: 'webp',
    q: String(quality),
  })
  return `${PROXY}?${params.toString()}`
}

export function optimizedSrcSet(
  url: string,
  widths: number[],
  quality?: number,
): string {
  return widths
    .map((width) => `${optimizedImage(url, width, quality)} ${width}w`)
    .join(', ')
}

/** Hero mockup: available widths and rendered width per breakpoint. */
export const HERO_WIDTHS = [480, 720, 960, 1240]
export const HERO_SIZES =
  '(min-width: 1024px) 580px, (min-width: 640px) 576px, calc(100vw - 48px)'
